import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface Props {}

export const TechFormsPendingPlaceholder: React.FC<Props> = () => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-6">
      <div className={twMerge("w-96 break-words text-center text-lg font-bold leading-6", theme.home.tailwind.textDefault)}>
        Pending forms will appear here
      </div>
      <div className={twMerge("w-96 break-words text-center text-base font-normal leading-5", theme.uwhcAssistant.text)}>
        Whenever a Cargill member sends a requirement for information related to the vessel it will appear here.
      </div>
    </div>
  );
};
